import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { AuthTwoFactorConfirmSetupPayload } from 'api/actions/auth-two-factor-confirm-setup/auth-two-factor-confirm-setup-payload';
import { AuthTwoFactorConfirmSetupPathParameters } from 'api/actions/auth-two-factor-confirm-setup/auth-two-factor-confirm-setup-path-parameters';
import { AuthTwoFactorConfirmSetupResponse } from 'api/actions/auth-two-factor-confirm-setup/auth-two-factor-confirm-setup-response';

type AuthTwoFactorConfirmSetupQueryParameters = Record<string, any>;

/**
 * The path of the AuthTwoFactorConfirmSetup action.
 */
export const authTwoFactorConfirmSetupActionPath = new SweetPath<keyof AuthTwoFactorConfirmSetupPathParameters>(
  '/api/auth/two-factor/setup/confirm',
  { path: '{param}' }
);

/**
 * Creates a contextualized AuthTwoFactorConfirmSetup actions.
 */
export default function createAuthTwoFactorConfirmSetupAction(axios: AxiosInstance) {
  return function authTwoFactorConfirmSetupAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: AuthTwoFactorConfirmSetupQueryParameters;
    payload: AuthTwoFactorConfirmSetupPayload;
  }) {
    const path = authTwoFactorConfirmSetupActionPath.original;

    return axios.request<AuthTwoFactorConfirmSetupResponse, AuthTwoFactorConfirmSetupResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
